"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomersPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var react_1 = require("react");
var customer_profile_1 = require("./customer_profile");
var customer_table_1 = require("./customer_table");
var customer_creation_1 = require("./customer_creation");
var console_1 = require("../../../../reducers/slices/console");
var react_redux_1 = require("react-redux");
var CustomersPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Customers"));
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: "h-full", children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { index: true, element: (0, jsx_runtime_1.jsx)(customer_table_1.CustomerTable, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "new", element: (0, jsx_runtime_1.jsx)(customer_creation_1.CustomerCreationPage, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: ":id", element: (0, jsx_runtime_1.jsx)(customer_profile_1.CustomerProfilePage, {}) })] }) }));
};
exports.CustomersPage = CustomersPage;
